import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { EntranceDoors } from 'landings/entrance-doors';
import { RemoteProps } from './widgets-types';

export const EntranceDoorsRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <EntranceDoors />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
